import { getAppStore, getEntity, Publisher } from '../../../../../@data';

export async function fetchPublisherProfileDetails(publisher: Publisher): Promise<Publisher> {
  const { userContext } = getAppStore();

  const publisherProfileDetails = await getEntity<Publisher>([publisher], userContext);
  return publisherProfileDetails;
}
